import queryString from "query-string";
import { useEffect, useState } from "react";
import {
  PolicyValidationView,
  normalizeValidationResults,
  ValidationResultItem,
} from "@platform/policy-validation-ui";
import { Close, constructUriWithSearchParams } from "@shared/ui";

import { getValidationResults } from "./lib/automatic";

const App = () => {
  const [loading, setLoading] = useState(true);
  const [validationResults, setValidationResults] = useState<
    ValidationResultItem[]
  >([]);
  const [error, setError] = useState<string>();
  const [origin, setOrigin] = useState<string>();
  const [redirectUri, setRedirectUri] = useState<string>();

  useEffect(() => {
    const {
      token,
      origin: originParam,
      redirectUri: redirectUriParam,
    } = queryString.parse(window.location.search);

    if (typeof originParam === "string") {
      setOrigin(originParam);
    }
    if (typeof redirectUriParam === "string") {
      setRedirectUri(redirectUriParam);
    }

    if (!token || typeof token !== "string") {
      setError("Missing token");
      setLoading(false);
      return;
    }

    (async () => {
      try {
        const data = await getValidationResults(token);
        setValidationResults(normalizeValidationResults(data));
      } catch (err) {
        console.error(err);
        setError("Unable to load validation results");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleClose = () => {
    if (origin) {
      window.parent.postMessage({ status: "exit" }, origin);
    } else if (redirectUri) {
      window.location.href = constructUriWithSearchParams(redirectUri, {
        status: "exit",
      });
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50">
      <div className="max-w-lg mx-auto relative border border-gray-300 rounded overflow-hidden bg-white">
        <button
          type="button"
          onClick={handleClose}
          aria-label="Close"
          className="absolute top-5 right-5 p-1"
        >
          <Close className="h-4 w-4" />
        </button>
        {error ? (
          <div>{error}</div>
        ) : (
          <PolicyValidationView
            title="Policy Validation"
            iconStatus="shimmer"
            loading={loading}
            validationResults={validationResults}
            validationActions={[]}
          />
        )}
        <div className="flex items-center justify-between px-8 py-3 bg-[#f4f4f5]">
          <p className="text-xs text-[#a1a1aa]">
            Powered by <span className="text-[15px] font-bold">Axle</span>
          </p>
          <p className="text-xs text-[#a1a1aa] flex gap-3">
            <a
              href="https://www.axle.insure/consumers"
              target="_blank"
              rel="noreferrer"
              className="text-[#a1a1aa]"
            >
              What&apos;s Axle?
            </a>
            <a
              href="https://www.axle.insure/legal/privacy-policy"
              target="_blank"
              rel="noreferrer"
              className="text-[#a1a1aa]"
            >
              Privacy
            </a>
            <a
              href="https://www.axle.insure/legal/end-user-terms"
              target="_blank"
              rel="noreferrer"
              className="text-[#a1a1aa]"
            >
              Terms
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default App;
